export default function FormActions({ loading, onClear }) {
  return (
    <div className="flex flex-col-reverse md:flex-row gap-3 md:items-center md:justify-between">
      <button
        type="button"
        className="rounded-2xl border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100 disabled:opacity-60"
        onClick={onClear}
        disabled={loading}
      >
        Clear
      </button>

      <button
        type="submit"
        disabled={loading}
        className="rounded-2xl border border-indigo-700 bg-indigo-600 px-4 py-2 text-sm font-semibold text-white hover:bg-indigo-700 disabled:opacity-60"
      >
        {loading ? "Creating..." : "Create owner + clinic"}
      </button>
    </div>
  );
}
